import React, { useEffect, useState, useMemo } from "react";
import "./GroupAvatar.css";
import { Avatar, Tooltip } from "antd";

const GroupAvatar = ({ maxCount, size, otherMember, data, isResponsiveCount = false, getMaxCount }) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    if (isResponsiveCount) {
      const handleResize = () => {
        setWindowSize(window.innerWidth);
      };
      window.addEventListener('resize', handleResize);
      handleResize();
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [])

  const maxResponsiveCount = useMemo(() => {
    if (isResponsiveCount) {
      return getMaxCount(windowSize);
    }
  }, [windowSize])

  return (
    <div className="avatar-groups">
      <Avatar.Group
        maxCount={isResponsiveCount ? maxResponsiveCount : maxCount}
        maxStyle={{ color: "#f56a00", backgroundColor: "#fde3cf" }}
        size={size}
      >
        {data?.length > 0 && data?.map((item, index) => (
          <Tooltip
            title={item?.first_name + " " + item?.last_name}
            placement="top"
            key={item?.first_name + index}
          >
            <Avatar src={item?.profile_picture} />
          </Tooltip>
        ))}
      </Avatar.Group>
      {/* {otherMember && <p>other Members</p>} */}
    </div>
  );
};

export default GroupAvatar;
